export default __webpack_public_path__ + "static/media/header_books.afbe0153.png";